const B = ["11110", "10001", "10001", "11110", "10001", "10001", "11110"];

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <rect width="32" height="32" rx="7" fill="#07090D" stroke="rgba(255,255,255,0.08)" />
    {B.flatMap((row, r) =>
      row.split("").map((c, i) =>
        c === "1" ? <rect key={`${r}-${i}`} x={7.4 + i * 3.6} y={3.4 + r * 3.6} width="3.2" height="3.2" fill="#00F0FF" /> : null
      )
    )}
    <rect x="21.8" y="3.4" width="3.2" height="3.2" fill="#FF2A40" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="flex flex-col leading-none">
      <span className="font-display text-[17px] font-extrabold tracking-[0.08em] text-white">BREWER</span>
      <span className="mt-1 font-mono text-[9px] tracking-[0.34em] text-slate-400">AMUSEMENT CO.</span>
    </span>
  </span>
);
